
import { Component, Prop, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { saveRole } from "@/api/api-basic";
import i18n from "@/config/i18n";
import regular from "@/common/regular";
@Component
export default class SystemConfigRoleInfo extends Vue {
  @Prop({ default: "" }) private selectRolePkId!: string;
  @Prop({
    default: () => {
      return [];
    },
    type: Array
  })
  private roleTypeList!: object[];
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  private privilege!: objAny;

  private roleName: objAny = {};
  private ruleInline: objAny = {
    roleName: [
      {
        required: true,
        validator: regular.name,
        trigger: "blur",
        name: i18n.t("role.roleName")
      }
    ],
    thRoleName: [
      {
        required: true,
        validator: regular.name,
        trigger: "blur",
        max: 100,
        name: i18n.t("role.thRoleName")
      }
    ],
    enRoleName: [
      {
        required: true,
        validator: regular.name,
        trigger: "blur",
        max: 100,
        name: i18n.t("role.enRoleName")
      }
    ],
    roleType: [
      { required: true, message: i18n.t("role.roleTypePl"), trigger: "change" }
    ]
  };
  private formItem: objAny = {
    remark: "",
    roleId: "",
    roleName: "",
    enRoleName: "",
    thRoleName: "",
    roleType: ""
    // sysId: "",
    // systemIds: [],
    // systemId: ""
  };
  private FormData: objAny = {};
  private loading = false;
  private itemData: objAny = {};

  public initData(data: objAny): void {
    this.handleReset();
    this.formItem = { ...data };
    this.formItem.roleId = data.rolePkId + "";
    this.formItem.roleType = data.roleType + "";
    if (this.formItem.roleId === "") {
      this.roleName = this.$refs["roleName"];
      this.roleName.focus();
    }
  }

  public handleSubmit(): void {
    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }

  public handleReset() {
    if (this.FormData) {
      this.FormData.resetFields();
    }
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const json = JSON.parse(JSON.stringify(this.formItem));
    json.roleType = parseInt(json.roleType);
    const ret = await saveRole(json);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess") + "");
      this.$emit("success");
    }
    this.loading = false;
  }

  mounted() {
    this.$nextTick((): void => {
      this.FormData = this.$refs["formInline"];
    });
  }
}
